import { Component, Input } from '@angular/core';
import { IUser } from '@shared/interfaces';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { millisecondsToDays } from '@shared/helpers/helpers';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-users-item',
    templateUrl: './admin-users-item.component.html',
    styleUrls: ['./admin-users-item.component.scss'],
    standalone: false
})
export class AdminUsersItemComponent extends AdminActionsDirective {
    leftDays: number;
    cssClass: { [key: string]: boolean };

    @Input() index: number;

    private _item: IUser;

    get item(): IUser {
        return this._item;
    }

    @Input() set item(val: IUser) {
        this._item = val;

        this.leftDays = millisecondsToDays(new Date(this._item.certificateExpiration).getTime() - new Date().getTime());
        this.cssClass = {
            // 'in-review': this.leftDays <= 30,
            // 'declined': this.leftDays <= 0 || !this.leftDays,
            // 'granted': this.leftDays > 30
        };
    }

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
